import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'app-smart-diagnosis-pest',
  templateUrl: './smart-diagnosis-pest.component.html',
  styleUrls: ['./smart-diagnosis-pest.component.scss'],
})
export class SmartDiagnosisPestComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
